import React from 'react';
import { ActionHeader } from '../../makeNct';
import AddNominee, { camsRelations, kfinRelations } from '../../makeNct/UpdateNominee/addNominee';
import {
    NOMINEEINFO,
    relationShips,
    RELATIONS,
} from '../../makeNct/UpdateNominee/update-nominee-edit';
import { getDate } from '../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { useHistory } from 'react-router';
import { UPDATE_PURCHASE_INFO } from '../../../../redux-store/types/newPurchase';
import { LoadProfileRoutes } from '.';
import enUs from '../../../../lang/en-us';

const { dashboard } = enUs;

function UpdatenomineePurchase(props: any) {
    const history = useHistory();
    const [nominees, setNominees] = React.useState<NOMINEEINFO[]>([]);
    const {
        purchaseDetails = {},
        pan,
        displayName,
    }: any = useSelector(({ newPurchase, authReducer }: RootStateType) => ({
        ...newPurchase,
        ...authReducer,
    }));
    const { nominees: nomineeDetails = [], address } = purchaseDetails;
    const { index, kfinFlag } = props.location.state;
    const dispatch = useDispatch();
    const relations = kfinFlag ? kfinRelations : camsRelations;
    React.useEffect(() => {
        setNominees(() =>
            nomineeDetails.map((_ele: any) => {
                let nomineeState = {
                    ..._ele,
                    relation: relations.includes(_ele?.relation)
                        ? _ele.relation
                        : dashboard.UpdateNominee.selectRelation,
                    name: _ele.name || '',
                    addressSameAsFH: _ele.addressSameAsFH || 'Y',
                    address1: address?.line1,
                    address2: address?.line2,
                    pincode: address?.pincode,
                    city: address?.city,
                    state: address?.state,
                    country: address?.country,
                    docName: _ele?.docName,
                    docValue: _ele?.docValue,
                    email: _ele?.email,
                    mobile: _ele?.mobile,
                    dob: getDate(_ele.dob),
                    share: _ele.percentage,
                    pan: _ele.pan,
                    gender: _ele.gender.toLowerCase(),
                    guardianName: _ele.nomineeGuardian?.name,
                    guardianPan: _ele.nomineeGuardian?.pan,
                    guardianAddress: _ele.nomineeGuardian?.address || '',
                    guardianDob: _ele.nomineeGuardian?.dob || '',
                    isEditable: false,
                    showDetails: false,
                    editShare: false,
                    isNewlyAdded: false,
                    id: _ele.id,
                    isEdited: false,
                };
                return { ...nomineeState, initialState: nomineeState };
            }),
        );
    }, []);
    const handleNomineeChange = (key: any, value: any, _index: number) => {
        const nominee: any[] = [...nominees];
        nominee[index][key] = value;
        setNominees(nominee);
    };
    const cancelFormSubmission = (index: number, id: string) => {
        // Reseting to intial state in redux after cancel;
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: { nominees: nomineeDetails },
        });
        history.goBack();
    };
    return (
        <div className="curved-bg">
            <ActionHeader header={'Nominee'} />
            <div className="curved-bg-content curved-bg-table-outer update-nominee-screen">
                <div className="curved-bg-content-table">
                    <div
                        className="curved-table-content update-nominee"
                        tabIndex={0}
                        aria-label="Nominee details"
                    >
                        <AddNominee
                            initialValues={nominees[index]}
                            index={index + 1}
                            handleNomineeChange={(key: string, value: any, ind: number) =>
                                handleNomineeChange(key, value, ind)
                            }
                            isKfin={kfinFlag}
                            nominees={nominees}
                            saveNominee={(key: string, value: any, ind: number) => {
                                const nominee: any = [...nominees];
                                const thisYear = new Date().getFullYear();
                                const nomineeDobYear = new Date(nominee[ind].dob).getFullYear();
                                nominee[ind] = {
                                    ...nominee[ind],
                                    name: nominee[ind].name,
                                    percentage: nominee[ind].share,
                                    gender: nominee[ind].gender,
                                    dob: nominee[ind].dob,
                                    pan: nominee[ind].pan,
                                    relation: nominee[ind].relation,
                                    city: nominee[ind].city,
                                    state: nominee[ind].state,
                                    nomineeGuardian:
                                        thisYear - nomineeDobYear < 18
                                            ? {
                                                  name: nominee[ind].guardianName,
                                                  pan: nominee[ind].guardianPan,
                                                  dob: nominee[ind].guardianDob,
                                              }
                                            : { name: '', pan: '', dob: '' },
                                };
                                dispatch({
                                    type: UPDATE_PURCHASE_INFO,
                                    body: { nominees: nominee },
                                });
                                history.goBack();
                            }}
                            relations={
                                nominees[index]?.relation
                                    ? relationShips.filter((relation: RELATIONS) => {
                                          const addedRelations = nominees
                                              .map((nominee: NOMINEEINFO) => {
                                                  if (nominee.relation !== nominees[index].relation)
                                                      return nominee.relation;
                                              })
                                              .filter((ele) => ele);
                                          return !addedRelations.includes(relation.label);
                                      })
                                    : relationShips.filter((relation: RELATIONS) => {
                                          const addedRelations = nominees.map(
                                              (_ele: NOMINEEINFO) => _ele.relation,
                                          );
                                          return !addedRelations.includes(relation.label);
                                      })
                            }
                            cancelFormSubmission={cancelFormSubmission}
                            investorName={purchaseDetails?.investorName}
                            pan={pan}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default (props: any) => LoadProfileRoutes(props, UpdatenomineePurchase);
